const IMGIX_SRCSET_HINT = /\.imgix\.net|[?&](?:auto|fit|crop|ar|dpr|q|w)=/i;

export const isImgixUrl = (url?: string): boolean => !!url && /\.imgix\.net/i.test(url);

export const buildImgixSrcSet = (url?: string): string | undefined => {
  if (!url || !IMGIX_SRCSET_HINT.test(url)) return undefined;

  const hashAt = url.indexOf('#');
  const base = hashAt === -1 ? url : url.slice(0, hashAt);
  const hash = hashAt === -1 ? '' : url.slice(hashAt);

  // A URL that already pins a dpr shouldn't get a conflicting srcset.
  if (/[?&]dpr=/i.test(base)) return undefined;

  const separator = base.includes('?') ? '&' : '?';

  return [
    `${base}${hash} 1x`,
    `${base}${separator}dpr=2${hash} 2x`,
    `${base}${separator}dpr=3${hash} 3x`,
  ].join(', ');
};
